import { useQuery } from '@apollo/client';
import useShopStore from '@app/shop/hooks/useShopStore';
import PRICING_PAGE_SHOP_PRODUCT_QUERY from './useShopProduct.query';
import {
  PricingPage_content_pricing_pages_layout_item_pricing_pages_single_layout_product as SingleLayoutProduct,
  PricingPage_content_pricing_pages_layout_item_pricing_pages_multi_layout_products_products_id as MultiLayoutProduct,
} from '../__generated__/PricingPage';
type DirectusProduct = SingleLayoutProduct | MultiLayoutProduct;
import {
  PricingPageShopProduct,
  PricingPageShopProductVariables,
} from './__generated__/PricingPageShopProduct';

const useShopProduct = (product: DirectusProduct | null) => {
  const sku = product?.sku;

  const { loading: useShopStoreLoading } = useShopStore();

  const { data, loading, error } = useQuery<
    PricingPageShopProduct,
    PricingPageShopProductVariables
  >(PRICING_PAGE_SHOP_PRODUCT_QUERY, {
    skip: !product || !sku || useShopStoreLoading,
    variables: { sku: sku! },
  });

  const magentoProduct = data?.magento2?.products?.items?.[0];

  const user = data?.user;
  const { isAuthenticated, country } = user ?? {};
  const notFound: boolean = !product || !magentoProduct;

  return {
    data,
    loading,
    error,
    magentoProduct,
    user,
    isAuthenticated,
    country,
    notFound,
  };
};

export default useShopProduct;
